import React from 'react';
import '../styles/StartScreen.css';

const StartScreen = ({ onStart }) => {
  return (
    <div className="start-screen">
      <div className="start-content">
        <h1 className="name-title">SHRESHTHAA</h1>
        <p className="subtitle">Generalist. Problem-solver. Builder.</p>
        <p className="neon-line">Unlocking levels since 2021</p>
        
        <button className="start-button" onClick={onStart}>
          Click here to play
        </button>
        
        <div className="instructions">
          <ul>
            <li>Eat glowing dots to unlock career facts</li>
            <li>Tap or press any key to dismiss fact cards</li>
            <li>Complete all 5 levels to finish</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default StartScreen;
